<template>
  <div class="game-act-manager" :class="{ 'gam-explore-mode': currentView === 'explore' }">
    <!-- 導航選單 -->
    <div class="nav-menu" v-show="showNavMenu">
      <div class="nav-title">{{ profile.name }}</div>
      <div class="nav-usage" v-if="activityUsage.loaded">
        {{ t('gameActManager.activityUsage') }}: {{ activityUsage.currentCount }} / {{ activityUsage.maxLimit }}
      </div>
      <div class="nav-item" @click="logout">登出</div>
    </div>

    <!-- 活動操作選單 -->
    <div class="actions" v-show="showActionMenu"
      :style="{ left: actionMenuPos.x + 'px', top: actionMenuPos.y + 'px' }">
      <div class="action-item" @click="openSettingModal()">{{ t('gameActManager.settings') }}</div>
      <template v-if="currentActivity?.currentGame === 'aigame'">
        <div class="action-item" v-if="!currentActivity?.isPublicDisplay" @click="openPublishDialog()">{{ t('gameActManager.publishToGallery') }}</div>
        <div class="action-item" v-else @click="openPublishDialog()">{{ t('gameActManager.updatePublicGame') }}</div>
      </template>
      <div class="action-item" @click="duplicateActivity()">{{ t('gameActManager.duplicate') }}</div>
      <div class="action-item" @click="confirmDeleteActivity()">{{ t('gameActManager.deleteAction') }}</div>
    </div>


    <!-- 中小螢幕搜尋框（全螢幕） -->
    <div class="search-box" v-show="showSearchBox">
      <div class="search-wrap">
        <div class="back-btn" @click="closeSearchBox()">
          <svg-icon icon-class="arrow-pre" />
        </div>

        <label class="search-bar">
          <template v-if="currentView === 'myGames'">
            <input :placeholder="t('gameActManager.searchPlaceholder')" v-model="search" @keyup.enter="searchGameActs()" />
            <div class="delete-btn" v-show="search.length !== 0" @click="resetSearch()">
              <svg-icon icon-class="close" />
            </div>
            <button type="submit" class="search-btn" @click="searchGameActs()" :disabled="search.length == 0">
              <svg-icon icon-class="search" class="search-icon" />
            </button>
          </template>
          <template v-else>
            <input :placeholder="t('gameActManager.searchPlaceholder')" v-model="publicSearch" @keyup.enter="searchPublicGames()" />
            <div class="delete-btn" v-show="publicSearch.length !== 0" @click="resetPublicSearch()">
              <svg-icon icon-class="close" />
            </div>
            <button type="submit" class="search-btn" @click="searchPublicGames()" :disabled="publicSearch.length == 0">
              <svg-icon icon-class="search" class="search-icon" />
            </button>
          </template>
        </label>
      </div>
    </div>

    <!-- 頂部 Navbar -->
    <div class="flex-bar" :class="{ 'flex-bar-arcade': currentView === 'explore', 'flex-bar-arcade-scrolled': currentView === 'explore' && isScrolled }">
      <!-- Explore mode: Arcade logo -->
      <div class="left" v-if="currentView === 'explore'">
        <div class="arcade-logo">
          <span class="arcade-logo-icon">
            <!-- game_controller_round [#795] — SVG Repo CC0 -->
            <svg width="20" height="20" viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
              <g transform="translate(-180,-4719)">
                <g transform="translate(56,160)">
                  <path d="M142,4570 C142,4569.448 141.552,4569 141,4569 L127,4569 C126.448,4569 126,4569.448 126,4570 L126,4576 C126,4576.552 126.448,4577 127,4577 L141,4577 C141.552,4577 142,4576.552 142,4576 L142,4570 Z M144,4569 L144,4577 C144,4578.105 143.105,4579 142,4579 L126,4579 C124.895,4579 124,4578.105 124,4577 L124,4569 C124,4567.895 124.895,4567 126,4567 L133,4567 L133,4563 C133,4561.895 133.895,4561 135,4561 L137,4561 C137.552,4561 138,4560.552 138,4560 L138,4559 L140,4559 L140,4561 C140,4562.105 139.105,4563 138,4563 L136,4563 C135.448,4563 135,4563.448 135,4564 L135,4567 L142,4567 C143.105,4567 144,4567.895 144,4569 L144,4569 Z M138,4574 L140,4574 L140,4572 L138,4572 L138,4574 Z M135,4572 C134.448,4572 134,4572.448 134,4573 C134,4573.552 134.448,4574 135,4574 C135.552,4574 136,4573.552 136,4573 C136,4572.448 135.552,4572 135,4572 L135,4572 Z M131,4572 L132,4572 L132,4574 L131,4574 L131,4575 L129,4575 L129,4574 L128,4574 L128,4572 L129,4572 L129,4571 L131,4571 L131,4572 Z"/>
                </g>
              </g>
            </svg>
          </span>
          <span class="arcade-logo-text">
            <span class="arcade-hiteach">HiTeach</span>
            <span class="arcade-name">ARCADE</span>
          </span>
        </div>
      </div>
      <!-- Normal mode: page title -->
      <div class="left" v-else>
        <div class="title">
          <span class="title-text">{{ t('gameActManager.pageTitle') }}</span>
        </div>
      </div>

      <!-- Right -->
      <div class="right" v-if="!isLogin">
        <div @click="loginTMID()" class="login-btn" :class="{ 'arcade-btn-ghost': currentView === 'explore' }">
          {{ currentView === 'explore' ? t('gameActManager.explore.loginBtn') : '登入' }}
        </div>
      </div>
      <div class="right" v-if="isLogin">
        <!-- Normal mode: search + mid-search-btn + avatar -->
        <template v-if="currentView !== 'explore'">
          <div class="search-wrap">
            <label class="search-bar">
              <template v-if="currentView === 'myGames'">
                <input :placeholder="t('gameActManager.searchPlaceholder')" v-model="search" />
                <div class="delete-btn" v-show="search.length !== 0" @click="resetSearch()">
                  <svg-icon icon-class="close" />
                </div>
                <button type="submit" class="search-btn" @click="searchGameActs()" :disabled="search.length == 0">
                  <svg-icon icon-class="search" class="search-icon" />
                </button>
              </template>
              <template v-else>
                <input :placeholder="t('gameActManager.searchPlaceholder')" v-model="publicSearch" @keyup.enter="searchPublicGames()" />
                <div class="delete-btn" v-show="publicSearch.length !== 0" @click="resetPublicSearch()">
                  <svg-icon icon-class="close" />
                </div>
                <button type="submit" class="search-btn" @click="searchPublicGames()" :disabled="publicSearch.length == 0">
                  <svg-icon icon-class="search" class="search-icon" />
                </button>
              </template>
            </label>
          </div>
          <div class="view-btn search-btn-mid" @click="openSearchBox()">
            <svg-icon icon-class="search" class="search-icon" />
          </div>
          <div class="avatar-wrap" @click="OpenAvatarMenu()">
            <img class="avatar" :src="profile.picture" alt="">
          </div>
        </template>
        <!-- Explore mode: my-games pill -->
        <template v-else>
          <div class="my-games-pill" @click="setView('myGames')">
            <span>{{ t('gameActManager.explore.myGamesBtn') }}</span>
            <img class="avatar" :src="profile.picture" alt="">
          </div>
        </template>
      </div>
    </div>

    <!-- 中小螢幕下拉選單按鈕 -->
    <div v-show="isLogin && currentView !== 'explore'" class="mid-title-btn" @click="openTitleMenu()"
      :class="{ 'active-mid-title-btn': showTitleMenu }">
      <div>{{ currentView === 'myGames' ? t('gameActManager.myActivities') : currentView === 'myPublic' ? t('gameActManager.myPublicDisplay') : t('gameActManager.explorePublicDisplay') }}
        <span><svg-icon icon-class="arrow-pre" class="arrow" :class="{ 'active-arrow': showTitleMenu }" /></span>
      </div>
    </div>

    <!-- 中小螢幕下拉選單 -->
    <div class="title-menu" v-show="showTitleMenu">
      <div class="title-item" @click="setView('myGames')">{{ t('gameActManager.myActivities') }}</div>
      <div class="title-item" @click="setView('myPublic')">{{ t('gameActManager.myPublicDisplay') }}</div>
      <div class="title-item" @click="setView('explore')">{{ t('gameActManager.explorePublicDisplay') }}</div>
    </div>

    <!-- 探索公開展示 - 完整頁面，在 sidebar-container 之外 -->
    <div v-if="currentView === 'explore'" class="gam-explore-page">

      <!-- Hero 區 -->
      <section class="gam-hero">
        <!-- 放射光暈 -->
        <div class="gam-hero-spotlight"></div>

        <!-- 閃爍星星 -->
        <!-- 星星避開標題中心區，只放四角和底部 -->
        <span class="gam-sparkle" style="left:8%;top:28%;color:#3B82F6;font-size:44px;--tdur:3.2s;--tdelay:0s">✦</span>
        <span class="gam-sparkle" style="left:30%;top:62%;color:#7B5DD7;font-size:36px;--tdur:2.6s;--tdelay:.7s">✦</span>
        <span class="gam-sparkle" style="left:88%;top:30%;color:#FF8A3D;font-size:44px;--tdur:3.4s;--tdelay:1.4s">✦</span>
        <span class="gam-sparkle" style="left:72%;top:66%;color:#14B8A6;font-size:38px;--tdur:2.8s;--tdelay:2.1s">✦</span>
        <span class="gam-sparkle" style="left:56%;top:78%;color:#4F46E5;font-size:36px;--tdur:3.6s;--tdelay:1.8s">✦</span>

        <!-- 分數彈出徽章 -->
        <!-- 分數徽章：英文版不顯示（避免遮擋長標題）-->
        <template v-if="locale !== 'en-US'">
          <div class="gam-score-popup" style="left:24%;top:22%;background:#3B82F6;--rot:-8deg;animation-delay:0s">+100</div>
          <div class="gam-score-popup" style="left:68%;top:22%;background:#7B5DD7;--rot:6deg;animation-delay:1.2s">COMBO x3</div>
          <div class="gam-score-popup" style="left:32%;top:68%;background:#FF8A3D;--rot:-6deg;animation-delay:.6s">★★★</div>
          <div class="gam-score-popup" style="left:64%;top:68%;background:#14B8A6;--rot:5deg;animation-delay:1.8s">WIN!</div>
        </template>

        <!-- 浮動卡帶（環形排列，跳過12點位以留TopBar空間） -->

        <!-- 打地鼠 - 10:30 -->
        <div class="gam-cartridge gam-floaty" style="left:9%;top:28%;--rot:-8deg;--delay:0s;--dur:7s;width:108px">
          <div class="gam-cart-inner" style="background:#3FB360">
            <svg viewBox="0 0 80 60" class="gam-cart-svg">
              <rect width="80" height="60" fill="#4DC970" rx="6"/>
              <ellipse cx="20" cy="45" rx="11" ry="6" fill="rgba(0,0,0,.35)"/>
              <ellipse cx="40" cy="48" rx="11" ry="6" fill="rgba(0,0,0,.35)"/>
              <ellipse cx="60" cy="45" rx="11" ry="6" fill="rgba(0,0,0,.35)"/>
              <ellipse cx="40" cy="30" rx="12" ry="13" fill="#8B5A2B"/>
              <circle cx="35" cy="26" r="3" fill="white"/>
              <circle cx="45" cy="26" r="3" fill="white"/>
              <circle cx="35" cy="26" r="1.5" fill="#333"/>
              <circle cx="45" cy="26" r="1.5" fill="#333"/>
              <rect x="0" y="54" width="80" height="6" fill="#5C3317" rx="2"/>
            </svg>
            <div class="gam-cart-label"><span class="gam-cart-title">{{ t('gameActManager.moleGameCard') }}</span></div>
          </div>
        </div>

        <!-- AI 自製 - 1:30 -->
        <div class="gam-cartridge gam-floaty" style="left:83%;top:8%;--rot:7deg;--delay:.8s;--dur:7.5s;width:108px">
          <div class="gam-cart-inner" style="background:#7B5DD7">
            <svg viewBox="0 0 80 60" class="gam-cart-svg">
              <rect width="80" height="60" fill="#9F85E5" rx="6"/>
              <circle cx="15" cy="12" r="6" fill="rgba(255,255,255,.2)"/>
              <circle cx="65" cy="50" r="8" fill="rgba(255,255,255,.15)"/>
              <circle cx="70" cy="15" r="4" fill="rgba(255,255,255,.2)"/>
              <text x="40" y="40" text-anchor="middle" font-size="28" font-weight="900" fill="white" font-family="sans-serif">AI</text>
              <polygon points="10,50 16,38 22,50" fill="rgba(255,255,255,.4)"/>
              <polygon points="60,10 66,22 54,22" fill="rgba(255,255,255,.35)"/>
            </svg>
            <div class="gam-cart-label"><span class="gam-cart-title">{{ t('gameActManager.aiGameCard') }}</span></div>
          </div>
        </div>

        <!-- 火箭升空 - 3:00 -->
        <div class="gam-cartridge gam-floaty" style="left:91%;top:40%;--rot:10deg;--delay:1.6s;--dur:6.5s;width:108px">
          <div class="gam-cart-inner" style="background:#1E3A8A">
            <svg viewBox="0 0 80 60" class="gam-cart-svg">
              <rect width="80" height="60" fill="#2D55C4" rx="6"/>
              <circle cx="8" cy="8" r="2" fill="rgba(255,255,255,.5)"/>
              <circle cx="20" cy="14" r="1.5" fill="rgba(255,255,255,.4)"/>
              <circle cx="60" cy="6" r="2.5" fill="rgba(255,255,255,.45)"/>
              <circle cx="72" cy="18" r="1.5" fill="rgba(255,255,255,.35)"/>
              <circle cx="15" cy="40" r="1.5" fill="rgba(255,255,255,.4)"/>
              <!-- Rocket body -->
              <ellipse cx="40" cy="28" rx="7" ry="14" fill="#FF8A3D"/>
              <ellipse cx="40" cy="18" rx="7" ry="6" fill="#FFBD3D"/>
              <!-- Fins -->
              <polygon points="33,38 28,46 33,44" fill="#FF8A3D"/>
              <polygon points="47,38 52,46 47,44" fill="#FF8A3D"/>
              <!-- Flame -->
              <ellipse cx="40" cy="46" rx="4" ry="6" fill="#FFDE6B" opacity=".9"/>
              <ellipse cx="40" cy="49" rx="2" ry="4" fill="white" opacity=".7"/>
            </svg>
            <div class="gam-cart-label"><span class="gam-cart-title">{{ t('gameActManager.rocketGameCard') }}</span></div>
          </div>
        </div>

        <!-- 貪食蛇 - 右中 -->
        <div class="gam-cartridge gam-floaty" style="left:80%;top:58%;--rot:-6deg;--delay:2.4s;--dur:7s;width:108px">
          <div class="gam-cart-inner" style="background:#0F1729">
            <svg viewBox="0 0 80 60" class="gam-cart-svg">
              <rect width="80" height="60" fill="#1A2540" rx="6"/>
              <!-- Grid lines -->
              <line x1="20" y1="0" x2="20" y2="60" stroke="#2A3A5A" stroke-width="1"/>
              <line x1="40" y1="0" x2="40" y2="60" stroke="#2A3A5A" stroke-width="1"/>
              <line x1="60" y1="0" x2="60" y2="60" stroke="#2A3A5A" stroke-width="1"/>
              <line x1="0" y1="20" x2="80" y2="20" stroke="#2A3A5A" stroke-width="1"/>
              <line x1="0" y1="40" x2="80" y2="40" stroke="#2A3A5A" stroke-width="1"/>
              <!-- Snake segments -->
              <rect x="8" y="28" width="14" height="12" rx="3" fill="#FF8A3D"/>
              <rect x="24" y="28" width="14" height="12" rx="3" fill="#FF8A3D"/>
              <rect x="44" y="28" width="14" height="12" rx="3" fill="#FF8A3D"/>
              <rect x="44" y="10" width="14" height="17" rx="3" fill="#FF8A3D"/>
              <!-- Apple -->
              <circle cx="65" cy="15" r="5" fill="#E94B3C"/>
              <line x1="65" y1="10" x2="65" y2="7" stroke="#4CAF50" stroke-width="1.5"/>
            </svg>
            <div class="gam-cart-label"><span class="gam-cart-title">{{ t('gameActManager.snakeGameCard') }}</span></div>
          </div>
        </div>

        <!-- 摘星星 - 6:00 -->
        <div class="gam-cartridge gam-floaty" style="left:calc(50% - 51px);top:76%;--rot:4deg;--delay:1.2s;--dur:8s;width:102px">
          <div class="gam-cart-inner" style="background:#FF8A3D">
            <svg viewBox="0 0 80 60" class="gam-cart-svg">
              <rect width="80" height="60" fill="#FFB37A" rx="6"/>
              <polygon points="40,8 43,18 54,18 45,25 48,35 40,28 32,35 35,25 26,18 37,18" fill="white"/>
              <polygon points="15,20 17,26 23,26 18,30 20,36 15,32 10,36 12,30 7,26 13,26" fill="rgba(255,255,255,.7)"/>
              <polygon points="65,30 67,36 73,36 68,40 70,46 65,42 60,46 62,40 57,36 63,36" fill="rgba(255,255,255,.65)"/>
              <!-- Ball -->
              <circle cx="60" cy="15" r="10" fill="#3B82F6" opacity=".85"/>
            </svg>
            <div class="gam-cart-label"><span class="gam-cart-title">{{ t('gameActManager.starGameCard') }}</span></div>
          </div>
        </div>

        <!-- 火箭升空 - 左中 -->
        <div class="gam-cartridge gam-floaty" style="left:16%;top:58%;--rot:8deg;--delay:2.0s;--dur:7.5s;width:108px">
          <div class="gam-cart-inner" style="background:#1E3A8A">
            <svg viewBox="0 0 80 60" class="gam-cart-svg">
              <rect width="80" height="60" fill="#2D55C4" rx="6"/>
              <circle cx="10" cy="10" r="2" fill="rgba(255,255,255,.5)"/>
              <circle cx="25" cy="5" r="1.5" fill="rgba(255,255,255,.4)"/>
              <circle cx="65" cy="8" r="2.5" fill="rgba(255,255,255,.45)"/>
              <circle cx="70" cy="22" r="1.5" fill="rgba(255,255,255,.35)"/>
              <ellipse cx="40" cy="28" rx="7" ry="14" fill="#FF8A3D"/>
              <ellipse cx="40" cy="18" rx="7" ry="6" fill="#FFBD3D"/>
              <polygon points="33,38 28,46 33,44" fill="#FF8A3D"/>
              <polygon points="47,38 52,46 47,44" fill="#FF8A3D"/>
              <ellipse cx="40" cy="46" rx="4" ry="6" fill="#FFDE6B" opacity=".9"/>
              <ellipse cx="40" cy="49" rx="2" ry="4" fill="white" opacity=".7"/>
            </svg>
            <div class="gam-cart-label"><span class="gam-cart-title">{{ t('gameActManager.rocketGameCard') }}</span></div>
          </div>
        </div>

        <!-- 迷宮 - 9:00 -->
        <div class="gam-cartridge gam-floaty" style="left:1%;top:56%;--rot:-10deg;--delay:.4s;--dur:6.5s;width:116px">
          <div class="gam-cart-inner" style="background:#2563EB">
            <svg viewBox="0 0 80 60" class="gam-cart-svg">
              <rect width="80" height="60" fill="#3B82F6" rx="6"/>
              <!-- Maze walls -->
              <g stroke="white" stroke-width="2.5" fill="none" stroke-linecap="round">
                <polyline points="10,10 30,10 30,30 50,30 50,10 70,10 70,50 50,50 50,55"/>
                <polyline points="10,10 10,40 30,40"/>
                <polyline points="10,55 40,55"/>
                <polyline points="70,50 75,50"/>
              </g>
              <!-- Start dot -->
              <circle cx="14" cy="14" r="3.5" fill="#FFDE6B"/>
              <!-- End dot -->
              <circle cx="74" cy="54" r="3.5" fill="white"/>
            </svg>
            <div class="gam-cart-label"><span class="gam-cart-title">{{ t('gameActManager.mazeGameCard') }}</span></div>
          </div>
        </div>

        <!-- 標題區 -->
        <div class="gam-hero-inner">
          <h1 class="gam-hero-title">
            {{ t('gameActManager.explore.heroTitle1') }}<span class="gam-title-blue" style="position:relative;display:inline-block">{{ t('gameActManager.explore.heroTitleHighlight') }}<svg viewBox="0 0 100 14" preserveAspectRatio="none" style="position:absolute;left:0;right:0;bottom:-8px;width:100%;height:14px"><path d="M 2,8 Q 25,2 50,7 T 98,6" stroke="#3B82F6" stroke-width="3.5" fill="none" stroke-linecap="round"/></svg></span>{{ t('gameActManager.explore.heroTitle2') }}<span class="gam-title-orange">{{ t('gameActManager.explore.heroTitleAccent') }}</span>{{ t('gameActManager.explore.heroTitle3') }}
          </h1>
          <p class="gam-hero-sub">{{ t('gameActManager.explore.heroSub') }}</p>
          <div class="gam-hero-cta">
            <button class="gam-btn-primary gam-wiggle" @click="openCreateGameGPT">
              + {{ t('gameActManager.explore.createBtn') }}
            </button>
          </div>
        </div>
      </section>

      <!-- 探索公開展示區 -->
      <section class="gam-explore-section">
          <!-- 標題列 -->
          <div class="gam-explore-header">
            <div class="gam-explore-header-left">
              <div class="gam-explore-title-row">
                <svg viewBox="0 0 60 74" xmlns="http://www.w3.org/2000/svg" width="22" height="28" aria-hidden="true" class="gam-flame-icon">
                  <path d="M30 72 C18 72 8 62 8 50 C8 38 14 28 20 20 C16 24 13 30 14 38 C11 32 12 22 18 14 C22 8 26 4 30 2 C34 4 38 8 42 14 C48 22 49 32 46 38 C47 30 44 24 40 20 C46 28 52 38 52 50 C52 62 42 72 30 72Z" fill="#D95F52"/>
                  <path d="M30 38 C24 42 20 48 20 55 C20 63 24 70 30 70 C36 70 40 63 40 55 C40 48 36 42 30 38Z" fill="#F6C12A"/>
                </svg>
                <h2 class="gam-explore-title">{{ t('gameActManager.explore.sectionTitle') }}</h2>
              </div>
              <p class="gam-explore-sub">{{ t('gameActManager.explore.sectionSub') }}</p>
            </div>
            <div class="gam-explore-search-wrap">
              <label class="gam-section-search">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="color:#8A8AA0;flex-shrink:0"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
                <input :placeholder="t('gameActManager.explore.searchPlaceholder')" v-model="exploreSearch" @keyup.enter="searchExploreGames()" />
                <div class="gam-del-btn" v-show="exploreSearch.length > 0" @click.stop="clearExploreSearch()">
                  <svg-icon icon-class="close" />
                </div>
              </label>
            </div>
          </div>

          <!-- 卡片格線 -->
          <div class="gam-explore-grid" v-if="exploreItems.length > 0">
            <div class="gam-arcade-card"
              v-for="(item, idx) in exploreItems" :key="item.id"
              @click="playExploreGame(item)">
              <!-- 縮圖區 (190px, 照心智圖) -->
              <div class="gam-card-img">
                <img v-if="item.snapshotUrl" :src="item.snapshotUrl" alt="" />
                <img v-else :src="require('@/assets/HTwbActAssets/home/cover-aigame.webp')" alt="" />
                <div class="gam-views-badge">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg>
                  {{ (item.viewCount || 0).toLocaleString() }}
                </div>
              </div>
              <!-- 資訊區 (照心智圖 gallery-card-info，亂數底色) -->
              <div class="gam-card-info" :style="{ background: exploreCardColors[idx] || '#fff' }">
                <div class="gam-card-meta">
                  <span class="gam-card-author">@ {{ item.publisher?.name }}</span>
                  <span class="gam-card-dot">·</span>
                  <span class="gam-card-date">{{ getTime(item.publishTime) }}</span>
                </div>
                <div class="gam-card-title">{{ item.title }}</div>
              </div>
            </div>
          </div>

          <!-- 空狀態 -->
          <div class="gam-explore-empty" v-else-if="!isLoadingExplore">
            {{ t('gameActManager.explore.noResults') }}
          </div>

          <!-- 載入更多 -->
          <div class="gam-load-more" v-if="exploreHasMore && !isLoadingExplore">
            <button class="gam-btn-ghost" @click="loadMoreExplore()">
              → {{ t('gameActManager.explore.loadMore') }}
              <span class="gam-load-more-count">{{ exploreTotal > 0 ? exploreTotal.toLocaleString() : '' }}</span>
            </button>
          </div>
      </section>

      <!-- Footer -->
      <div class="gam-footer">
        <span>{{ $t('mindmap.copyright') }}</span>
      </div>
    </div>

    <!--SideBar-->
    <div class="sidebar-container" v-show="isLogin && currentView !== 'explore'">
      <div class="sidebar">
        <!--新增按鈕-->
        <div class="add-btn" @click="handleAddButtonClick" ref="addButtonRef">+ {{ t('gameActManager.addNew') }}</div>

        <!-- 步驟一引導：僅在我的遊戲活動、無搜尋、列表真正為空時顯示 -->
        <GuideStep1 v-if="currentView === 'myGames' && search === '' && gameActivityList.length === 0" ref="guideStep1Ref" />

        <div class="sidebar-content">
          <div class="sidebar-item" :class="{ active: currentView === 'myGames' }" @click="setView('myGames')">{{ t('gameActManager.myActivities') }}</div>
          <div class="sidebar-item" :class="{ active: currentView === 'myPublic' }" @click="setView('myPublic')">{{ t('gameActManager.myPublicDisplay') }}</div>
          <div class="sidebar-divider"></div>
          <div class="sidebar-item" :class="{ active: currentView === 'explore' }" @click="setView('explore')">{{ t('gameActManager.explorePublicDisplay') }}</div>
        </div>
      </div>

      <div class="content">
        <!--我的公開展示 view-->
        <div class="activity-grid" v-if="currentView === 'myPublic'">
          <div class="activity-card-wrap" v-if="myPublicGameList.length > 0">
            <div class="card-item" v-for="item in myPublicGameList" :key="item.id">
              <div class="img-top" :style="{ backgroundImage: `url(${getPublicGameImage(item)})` }" @click="openPublicViewModal(item)">
              </div>
              <div class="card-textwrap" @click="openPublicViewModal(item)">
                <h5>{{ item.title }}</h5>
                <p class="update-time">{{ getTime(item.publishTime) }}</p>
              </div>
              <div class="public-view-count" v-if="item.viewCount">
                <svg-icon icon-class="eye" class="view-count-icon" />
                <span>{{ item.viewCount }}</span>
              </div>
              <div class="more-btn" @click="openPublicActionMenu(item, $event)">
                <svg-icon icon-class="more" />
              </div>
            </div>
          </div>
          <div class="text-md ml-8 mt-8 font-bold" v-else-if="!isLoadingPublic">
            {{ t('gameActManager.noPublicGames') }}
          </div>
        </div>

        <!--gridView-->
        <div class="activity-grid" v-if="currentView === 'myGames'">
          <div class="activity-card-wrap" v-if="gameActivityList.length > 0">
            <div class="card-item" v-for="activity in gameActivityList" :key="activity.id">
              <div class="img-top" @click="clickActivityItem(activity)" :style="{ backgroundImage: `url(${getActivityBackgroundImage(activity)})` }">
                <!-- 背景圖片 -->
              </div>

              <div class="card-textwrap">
                <h5 @click="clickActivityItem(activity)">{{ activity.activityName }}</h5>
                <p class="update-time">{{ getTime(activity.updateTime) }}</p>
              </div>

              <!-- 左下角綠燈指示器（開放進入活動時顯示） -->
              <div class="status-indicator" v-if="activity.enableEntry">
                <span class="status-dot"></span>
                <span class="status-text">{{ t('gameActManager.statusOpen') }}</span>
              </div>

              <div class="more-btn" @click="openActionMenu(activity, $event)">
                <svg-icon icon-class="more" />
              </div>
              <p class="share" v-show="activity.isPublished">
                <svg-icon iconClass="eye"></svg-icon>
                <span class="publish-note-text">已發布</span>
              </p>
            </div>
          </div>
          <div class="text-md ml-8 mt-8 font-bold" v-else>
            {{ t('gameActManager.noActivities') }}
          </div>
        </div>
      </div>
    </div>

    <!-- 公開展示操作選單 -->
    <div class="actions" v-show="showPublicActionMenu"
      :style="{ left: publicActionMenuPos.x + 'px', top: publicActionMenuPos.y + 'px' }">
      <div class="action-item" @click="openPublicViewModal(currentPublicGame)">{{ t('gameActManager.viewPublicGame') }}</div>
      <div class="action-item" @click="confirmDeletePublicGame()">{{ t('gameActManager.deletePublicGame') }}</div>
    </div>

    <!-- 檢視公開展示 Modal -->
    <div v-show="showPublicViewModal" class="modal-overlay" @click.self="showPublicViewModal = false">
      <div class="modal-content public-view-modal">
        <div class="modal-header">
          <h3>{{ publicViewItem?.title }}</h3>
          <button class="close-btn" @click="showPublicViewModal = false">
            <svg-icon icon-class="close" />
          </button>
        </div>
        <div class="modal-body">
          <div class="view-link-row">
            <div class="url-wrap" v-if="publicViewItem?.publicGameCode">
              <span class="url-title">URL：{{ shortURLHost }}</span>
              <span class="short-url">{{ publicViewItem.publicGameCode }}</span>
              <span class="copy-btn" @click="copyPublicViewUrl">
                <svg-icon icon-class="copy" />
              </span>
              <span class="qrcode-btn" @click="openPublicViewQRCode">
                <svg-icon icon-class="qrcode-new" />
              </span>
            </div>
            <div class="url-wrap" v-else>
              <span class="url-title">URL：</span>
              <span style="color:#999;font-size:14px;">尚未產生短網址</span>
            </div>
            <button type="button" class="play-now-btn" @click="playPublicGame(publicViewItem)">
              {{ t('gameActManager.tryNow') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 刪除公開版本確認視窗 -->
    <div v-show="showPublicDeleteConfirm" class="modal-overlay">
      <div class="modal-content delete-confirm-modal">
        <div class="modal-header">
          <h3>{{ t('gameActManager.deletePublicConfirmTitle') }}</h3>
          <button class="close-btn" @click="showPublicDeleteConfirm = false">
            <svg-icon icon-class="close" />
          </button>
        </div>
        <div class="modal-body">
          <p class="confirm-text">{{ t('gameActManager.deletePublicConfirmMessage') }}</p>
          <p class="warning-text danger-color">{{ publicGameToDelete?.title }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="cancel-btn" @click="showPublicDeleteConfirm = false" :disabled="isDeletingPublic">
            {{ t('gameActManager.cancel') }}
          </button>
          <button type="button" class="delete-btn" @click="doDeletePublicGame" :disabled="isDeletingPublic">
            <span v-if="isDeletingPublic" class="loading-spinner"></span>
            {{ isDeletingPublic ? t('gameActManager.deleting') : t('gameActManager.delete') }}
          </button>
        </div>
      </div>
    </div>

    <!-- 分頁 - 我的遊戲活動 -->
    <div class="page-btn-wrap" v-if="isLogin && currentView === 'myGames' && gameActivityList.length > 0">
      <div v-for="pageBtn in pageBtns" :key="pageBtn" class="page-btn"
        :class="{ 'page-btn-active': pageBtn == currentPageNum }"
        @click="getActivityListByPage(pageBtn)">
        {{ pageBtn }}
      </div>
    </div>

    <!-- 分頁 - 我的公開展示 -->
    <div class="page-btn-wrap" v-if="isLogin && currentView === 'myPublic' && publicTotalPages > 1">
      <div v-for="pageBtn in publicPageBtns" :key="pageBtn" class="page-btn"
        :class="{ 'page-btn-active': pageBtn == publicCurrentPage }"
        @click="loadMyPublicGames(pageBtn)">
        {{ pageBtn }}
      </div>
    </div>

    <!-- 新增活動 Modal -->
    <CreateActivityModal
      v-if="showCreateModal"
      :question-type="selectedQuestionType"
      :creator="{ id: profile.teammodelId, name: profile.name }"
      :default-settings="defaultGameSettings"
      :activity-count="gameActivityList.length"
      @close="handleModalClose"
      @created="handleActivityCreated"
    />

    <!-- 更新活動 Modal -->
    <UpdateActivityModal
      v-if="showUpdateModal"
      :activity="currentActivity"
      :creator="{ id: profile.teammodelId, name: profile.name }"
      :activity-count="gameActivityList.length"
      @close="handleUpdateModalClose"
      @updated="handleActivityUpdated"
    />

    <!-- 刪除確認視窗 -->
    <div v-show="showDeleteConfirm" class="modal-overlay">
      <div class="modal-content delete-confirm-modal">
        <div class="modal-header">
          <h3>{{ t('gameActManager.deleteConfirmTitle') }}</h3>
          <button class="close-btn" @click="closeDeleteConfirm">
            <svg-icon icon-class="close" />
          </button>
        </div>
        <div class="modal-body">
          <p class="confirm-text">{{ t('gameActManager.deleteConfirmMessage') }}</p>
          <p class="warning-text danger-color">{{ activityToDelete?.activityName }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="cancel-btn" @click="closeDeleteConfirm" :disabled="isDeleting">
            {{ t('gameActManager.cancel') }}
          </button>
          <button type="button" class="delete-btn" @click="confirmDelete" :disabled="isDeleting">
            <span v-if="isDeleting" class="loading-spinner"></span>
            {{ isDeleting ? t('gameActManager.deleting') : t('gameActManager.delete') }}
          </button>
        </div>
      </div>
    </div>

    <!-- 公開發佈 Dialog -->
    <div v-show="showPublishDialog" class="modal-overlay">
      <div class="modal-content publish-dialog-modal">
        <div class="modal-header">
          <h3>{{ currentActivity?.isPublicDisplay ? t('gameActManager.publishDialog.updateTitle') : t('gameActManager.publishDialog.title') }}</h3>
          <button class="close-btn" @click="closePublishDialog">
            <svg-icon icon-class="close" />
          </button>
        </div>
        <div class="modal-body">
          <div v-if="currentActivity?.isPublicDisplay" class="overwrite-hint">
            {{ t('gameActManager.publishDialog.overwriteHint') }}
          </div>
          <div class="form-group">
            <input class="form-input" v-model="publishTitle" :placeholder="t('gameActManager.publishDialog.displayTitlePlaceholder')" maxlength="20" />
          </div>
          <div class="form-group source-code-group">
            <label class="toggle-label">
              <span class="toggle-text">
                <span class="toggle-name">{{ t('gameActManager.publishDialog.sourceCodeLabel') }}</span>
                <span class="toggle-desc">{{ t('gameActManager.publishDialog.sourceCodeDesc') }}</span>
              </span>
              <input type="checkbox" v-model="publishSourceCodeOpen" class="toggle-checkbox" />
            </label>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="cancel-btn" @click="closePublishDialog" :disabled="isPublishing">
            {{ t('gameActManager.cancel') }}
          </button>
          <button type="button" class="confirm-btn" @click="confirmPublish" :disabled="isPublishing || !publishTitle.trim()">
            <span v-if="isPublishing" class="loading-spinner"></span>
            {{ currentActivity?.isPublicDisplay ? t('gameActManager.publishDialog.confirmUpdate') : t('gameActManager.publishDialog.confirm') }}
          </button>
        </div>
      </div>
    </div>

    <!-- 公開發佈成功 Modal -->
    <div v-show="showPublishSuccessModal && !showQRCodeCard" class="modal-overlay">
      <div class="modal-content publish-success-modal">
        <div class="modal-header">
          <h3>{{ publishTitle }}</h3>
          <button class="close-btn" @click="showPublishSuccessModal = false">
            <svg-icon icon-class="close" />
          </button>
        </div>
        <div class="modal-body">
          <div class="url-wrap">
            <span class="url-title">{{ t('gameActManager.publishSuccess.urlLabel') }}：</span>{{ shortURLHost }}<span class="short-url">{{ publishedGameCode }}</span>
            <span class="copy-btn" @click="copyPublicId">
              <svg-icon icon-class="copy" />
            </span>
            <span class="qrcode-btn" @click="openPublishQRCode">
              <svg-icon icon-class="qrcode-new" />
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- QR Code Dialog -->
    <QRCodeDialog
      v-if="showQRCodeCard"
      :url="qrCodeUrl"
      :short-code="publishedGameCode"
      :short-u-r-l-host="shortURLHost"
      theme-color="#667eea"
      @close="showQRCodeCard = false"
    />

    <!-- 遊戲選擇彈出視窗 -->
    <div class="popup-overlay" v-if="showGameSelectionModal" @click="closeGameSelectionModal"></div>
    <div class="game-selection-popup" v-if="showGameSelectionModal">
      <div class="popup-header">
        <h2>{{ t('gameActManager.selectGameType') }}</h2>
        <div class="close-btn" @click="closeGameSelectionModal">
          <svg-icon icon-class="close" />
        </div>
      </div>
      <div class="popup-content">
        <div class="game-grid">
          <div class="game-item" @click="createGameActivity('mole', 'recognition')">
            <div class="game-card">
              <img :src="require('@/assets/HTwbActAssets/home/cover-molegame.webp')" :alt="t('gameActManager.moleGameCard')">
              <div class="game-name">{{ t('gameActManager.moleGameCard') }}</div>
            </div>
          </div>
          <div class="game-item" @click="createGameActivity('star', 'recognition')">
            <div class="game-card">
              <img :src="require('@/assets/HTwbActAssets/home/cover-pvpgame.webp')" :alt="t('gameActManager.starGameCard')">
              <div class="game-name">{{ t('gameActManager.starGameCard') }}</div>
            </div>
          </div>
          <div class="game-item" @click="createGameActivity('tf', 'trueFalse')">
            <div class="game-card">
              <img :src="require('@/assets/HTwbActAssets/home/cover-tfgame.webp')" :alt="t('gameActManager.rocketGameCard')">
              <div class="game-name">{{ t('gameActManager.rocketGameCard') }}</div>
            </div>
          </div>
          <div class="game-item" @click="createGameActivity('snake', 'recognition')">
            <div class="game-card">
              <img :src="require('@/assets/HTwbActAssets/home/cover-snakegame.webp')" :alt="t('gameActManager.snakeGameCard')">
              <div class="game-name">{{ t('gameActManager.snakeGameCard') }}</div>
            </div>
          </div>
          <div class="game-item" @click="createGameActivity('maze', 'multiChoice')">
            <div class="game-card">
              <img :src="require('@/assets/HTwbActAssets/home/cover-mazegame.webp')" :alt="t('gameActManager.mazeGameCard')">
              <div class="game-name">{{ t('gameActManager.mazeGameCard') }}</div>
            </div>
          </div>
          <div class="game-item" @click="createGameActivity('aigame', 'aiGenerated')">
            <div class="game-card">
              <img :src="require('@/assets/HTwbActAssets/home/cover-aigame.webp')" :alt="t('gameActManager.aiGameCard')">
              <div class="game-name">{{ t('gameActManager.aiGameCard') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/*eslint-disable*/
import { ref, reactive, onMounted, onBeforeUnmount, inject, toRaw } from 'vue';
import { useQuasar } from 'quasar';
import { useI18n } from 'vue-i18n';
import { useRouter, useRoute } from 'vue-router';
import jwt_decode from "jwt-decode";
import SvgIcon from "../components/SvgIcon.vue";
import CreateActivityModal from "./components/CreateActivityModal.vue";
import UpdateActivityModal from "./components/UpdateActivityModal.vue";
import GuideStep1 from "./components/GuideStep1.vue";
import QRCodeDialog from "@/components/QRCodeDialog.vue";
import { useMainStore } from "../stores/mainStore";
import api from "@/api";
import gameActivityAPI from "@/api/gameActivityAPI";
import confProfile from "@/api/profile";

const store = useMainStore();
const $q = useQuasar();
const router = useRouter();
const route = useRoute();
const $Message = inject('$Message');
const { t, locale } = useI18n();

// 使用者資料
const profile = reactive({
  name: '',
  picture: '',
  teammodelId: ''
});

// UI 狀態
const isLogin = ref(false);
const showNavMenu = ref(false);
const isScrolled = ref(false);
const handleExploreScroll = () => {
  isScrolled.value = window.scrollY > 20;
};
const showActionMenu = ref(false);
const showAddMenu = ref(false);
const showSearchBox = ref(false);
const showGameSelectionModal = ref(false);
const showTitleMenu = ref(false);
const search = ref('');
const currentPageNum = ref(1);
const totalPages = ref(1);

// 活動用量狀態
const activityUsage = reactive({
  loaded: false,
  currentCount: 0,
  maxLimit: 120,
  remainingCount: 0,
  canCreate: true,
  isNearLimit: false
});

// 遊戲活動列表
const gameActivityList = ref([]);
const currentActivity = ref(null);

// 目前 view
const currentView = ref('explore');

// 我的公開展示
const myPublicGameList = ref([]);
const isLoadingPublic = ref(false);
const showPublicActionMenu = ref(false);
const publicActionMenuPos = reactive({ x: 0, y: 0 });
const currentPublicGame = ref(null);
const showPublicDeleteConfirm = ref(false);
const publicGameToDelete = ref(null);
const isDeletingPublic = ref(false);
const publicCurrentPage = ref(1);
const publicTotalPages = ref(1);
const publicPageBtns = ref([1]);
const publicSearch = ref('');
const showPublicViewModal = ref(false);
const publicViewItem = ref(null);

// 探索公開展示
const exploreItems = ref([]);
const isLoadingExplore = ref(false);
const exploreSearch = ref('');
const explorePage = ref(1);
const exploreHasMore = ref(false);
const exploreTotal = ref(0);

// 卡片底色（照心智圖 CARD_COLORS）
const EXPLORE_CARD_COLORS = ['#d4f0e3', '#e4dffa', '#fdddd5', '#fdf3c0', '#d6eeff'];
const exploreCardColors = ref([]);
const genExploreCardColors = (count, prev = []) => {
  const seq = [...prev];
  for (let i = seq.length; i < count; i++) {
    const last = seq[i - 1];
    const pool = EXPLORE_CARD_COLORS.filter(c => c !== last);
    seq.push(pool[Math.floor(Math.random() * pool.length)]);
  }
  return seq;
};

// 刪除確認相關
const showDeleteConfirm = ref(false);
const activityToDelete = ref(null);
const isDeleting = ref(false);

// 公開發佈相關
const showPublishDialog = ref(false);
const showPublishSuccessModal = ref(false);
const publishTitle = ref('');
const publishSourceCodeOpen = ref(false);
const isPublishing = ref(false);
const publishedPublicId = ref('');
const publishedGameCode = ref('');
const showQRCodeCard = ref(false);
const qrCodeUrl = ref('');
const shortURLHost = confProfile.shortUrlHost[api.main.getServerLocation()];

// 分頁按鈕
const pageBtns = ref([1]);

// 選單位置
const actionMenuPos = reactive({
  x: 0,
  y: 0
});

// 初始化認證
const initializeAuth = async () => {
    try {
        const res = await api.main.getTokenUnlogin();
        const exp = jwt_decode(res.auth_token).exp
        localStorage.setItem("auth_token", res.auth_token);
        localStorage.setItem("auth_token_expiry", exp);
    } catch (error) {
        console.error("Error fetching auth token ", error);
    }
}

// 初始化
onMounted(async () => {
    // 先載入探索資料（不需登入，立即顯示首頁）
    loadExploreGames();

    try {
        await initializeAuth();
    } catch (error) {
        console.error("Error fetching auth token:", error);
    }

    document.addEventListener('click', handleNavClickOutside);
    document.addEventListener('click', handleActionMenuClickOutside);
    document.addEventListener('click', handleAddMenuClickOutside);
    document.addEventListener('click', handleTitleMenuClickOutside);
    window.addEventListener('scroll', handleExploreScroll);

    // 優先檢查 URL 中是否有 code 參數
    let url = new URL(window.location.href);
    let code = url.searchParams.has("code") == true ? url.searchParams.get("code") : "";

    if (code) {
        localStorage.removeItem("access_token");
        localStorage.removeItem("expires_in");
        localStorage.removeItem("profile");
        //登入取得token
        api.main
            .getToken()
            .then(async (res) => {
                localStorage.setItem("id_token", res.id_token);
                const decoded = jwt_decode(res.id_token);

                isLogin.value = true;
                store.setIsLogIn(true);
                profile.name = decoded.name;
                profile.teammodelId = decoded.sub;
                profile.picture = decoded.picture;

                //將access_token存本地, http 攔截器使用
                localStorage.setItem("access_token", res.access_token);
                localStorage.setItem("expires_in", res.expires_in);

                localStorage.setItem(
                    "profile",
                    JSON.stringify({
                        name: profile.name,
                        id: profile.teammodelId,
                        picture: profile.picture,
                    })
                );

                $q.loading.show();
                await loadGameActivities();
                $q.loading.hide();

                const savedView = localStorage.getItem(`gameact_view_preference_${profile.teammodelId}`);
                if (savedView && ['myGames', 'myPublic', 'explore'].includes(savedView)) {
                    await setView(savedView);
                } else {
                    currentView.value = 'myGames';
                }

                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                url.searchParams.delete('state');
                url.searchParams.delete('clientId');
                window.history.replaceState({}, document.title, url.toString());
            })
            .catch((err) => {
                console.log(err);
            });
    }
    // 檢查是否已有登入資料（包含從 HT 跳轉或一般登入）
    else if (localStorage.getItem("profile") && localStorage.getItem("access_token")) {
        isLogin.value = true;
        let localeProfile = JSON.parse(localStorage.getItem("profile"));
        profile.name = localeProfile.name;
        profile.teammodelId = localeProfile.id || localeProfile.teammodelId;
        profile.picture = localeProfile.picture;

        try {
            $q.loading.show();
            await loadGameActivities();
            await loadActivityUsage();
            $q.loading.hide();

            // URL query 優先（如從複製跳轉指定視圖），否則讀上次偏好
            const queryView = route.query.view;
            if (queryView && ['myGames', 'myPublic', 'explore'].includes(queryView)) {
                await setView(queryView);
            } else {
                const savedView = localStorage.getItem(`gameact_view_preference_${profile.teammodelId}`);
                if (savedView && ['myGames', 'myPublic', 'explore'].includes(savedView)) {
                    await setView(savedView);
                } else {
                    currentView.value = 'myGames';
                }
            }

            // 執行登入前的 pendingAction（如未登入點複製到我的遊戲）
            const pendingStr = localStorage.getItem('pendingAction');
            if (pendingStr) {
                try {
                    const pending = JSON.parse(pendingStr);
                    localStorage.removeItem('pendingAction');
                    if (pending.action === 'copyPublicAIGame' && pending.publicId) {
                        const res = await gameActivityAPI.copyPublicGame({
                            publicId: pending.publicId,
                            creator: { id: profile.teammodelId, name: profile.name }
                        });
                        if (res?.status === 200) {
                            $Message.success(t('gameActManager.copySuccess'));
                            await loadGameActivities();
                            await setView('myGames');
                        } else {
                            $Message.error(t('gameActManager.copyGameFailed'));
                        }
                    }
                } catch (e) {
                    console.error('[GameActManager] pendingAction 執行失敗:', e);
                    localStorage.removeItem('pendingAction');
                }
            }
        } catch (error) {
            $q.loading.hide();
            console.error('載入遊戲活動失敗:', error);
        }
    }
});

onBeforeUnmount(() => {
    document.removeEventListener('click', handleNavClickOutside);
    document.removeEventListener('click', handleActionMenuClickOutside);
    document.removeEventListener('click', handleAddMenuClickOutside);
    document.removeEventListener('click', handleTitleMenuClickOutside);
    window.removeEventListener('scroll', handleExploreScroll);
});

// 載入活動用量資訊
const loadActivityUsage = async () => {
  try {
    const request = {
      tmid: profile.teammodelId
    };

    const res = await gameActivityAPI.checkActivityLimit(request);
    console.log('[GameActManager] 用量查詢結果:', res);

    if (res && res.data) {
      activityUsage.currentCount = res.data.currentCount || 0;
      activityUsage.maxLimit = res.data.maxLimit || 120;
      activityUsage.remainingCount = res.data.remainingCount || 0;
      activityUsage.canCreate = res.data.canCreate !== false;
      activityUsage.isNearLimit = res.data.isNearLimit || false;
      activityUsage.loaded = true;
    }
  } catch (err) {
    console.error('載入活動用量失敗:', err);
    activityUsage.loaded = false;
  }
};

// 載入遊戲活動列表（改為呼叫後端 API）
const loadGameActivities = async () => {
  try {
    const request = {
      tmid: profile.teammodelId, // 必填：登入者 ID
      sortOrder: 'desc',
      sortField: 'createTime',
      pageSize: 12, // 與前端每頁顯示數一致
      pageNumber: currentPageNum.value,
      searchText: (search.value || '').trim()
    };

    const res = await gameActivityAPI.getMyGameActivities(request);
    // 後端回傳 { status, data, totalPages }
    gameActivityList.value = Array.isArray(res.data) ? res.data : [];
    totalPages.value = res.totalPages || 1;
    updatePagination();

    // 用量資訊不在每次列表刷新時查詢，改為只在新增/刪除後更新
  } catch (err) {
    console.error('載入遊戲活動失敗:', err);
    gameActivityList.value = [];
    totalPages.value = 1;
    updatePagination();
  }
};

// 更新分頁
const updatePagination = () => {
  const pages = [];
  for (let i = 1; i <= totalPages.value; i++) {
    pages.push(i);
  }
  pageBtns.value = pages;
};

// 搜尋
const searchGameActs = async () => {
  currentPageNum.value = 1;
  await loadGameActivities();
};

const resetSearch = () => {
  search.value = '';
  searchGameActs();
};

// 開啟搜尋框（中小螢幕）
const openSearchBox = () => {
  showSearchBox.value = true;
};

// 關閉搜尋框（中小螢幕）
const closeSearchBox = () => {
  showSearchBox.value = false;
};

// 分頁切換
const getActivityListByPage = async (pageNum) => {
  currentPageNum.value = pageNum;
  await loadGameActivities();
};

// 點擊活動卡片 - 直接開啟設定 Modal
const clickActivityItem = (activity) => {
  console.log('點擊活動:', toRaw(activity));
  currentActivity.value = activity;
  showUpdateModal.value = true;
};

// 開啟操作選單
const openActionMenu = (activity, event) => {
  event.stopPropagation();
  currentActivity.value = activity;

  // 計算選單位置
  const rect = event.target.getBoundingClientRect();
  actionMenuPos.x = rect.left - 60;
  actionMenuPos.y = rect.top + 20;

  showActionMenu.value = true;
};

// 點擊外部關閉操作選單
const handleActionMenuClickOutside = (event) => {
  if (!event.target.closest('.actions') && !event.target.closest('.more-btn')) {
    showActionMenu.value = false;
    showPublicActionMenu.value = false;
  }
};

// 開啟設定 Modal（更新活動）
const openSettingModal = () => {
  showActionMenu.value = false;
  if (currentActivity.value) {
    showUpdateModal.value = true;
  }
};

// 開啟刪除確認視窗
const confirmDeleteActivity = () => {
  showActionMenu.value = false;
  if (currentActivity.value) {
    activityToDelete.value = currentActivity.value;
    showDeleteConfirm.value = true;
  }
};

// 關閉刪除確認視窗
const closeDeleteConfirm = () => {
  showDeleteConfirm.value = false;
  activityToDelete.value = null;
};

// 確認刪除活動
const confirmDelete = async () => {
  if (!activityToDelete.value || isDeleting.value) return;

  isDeleting.value = true;

  try {
    console.log('開始刪除活動:', activityToDelete.value);

    // 呼叫刪除 API
    const response = await gameActivityAPI.deleteGameActivity({
      id: activityToDelete.value.id
    });

    console.log('刪除 API 回應:', response);

    if (response && response.status === 200) {
      $Message.success(t('gameActManager.activityDeleted'));
      closeDeleteConfirm();

      // 重新載入活動列表並更新用量（刪除後用量減少）
      $q.loading.show();
      await loadGameActivities();
      await loadActivityUsage();
      $q.loading.hide();
    } else {
      throw new Error('刪除請求失敗');
    }
  } catch (error) {
    console.error('刪除活動失敗:', error);
    $Message.error(error.message || t('gameActManager.activityDeleteFailed'));
  } finally {
    isDeleting.value = false;
  }
};

// 公開展示搜尋
const searchPublicGames = async () => {
  publicCurrentPage.value = 1;
  await loadMyPublicGames();
};

const resetPublicSearch = () => {
  publicSearch.value = '';
  searchPublicGames();
};

// 中小螢幕下拉選單
const openTitleMenu = () => {
  showTitleMenu.value = !showTitleMenu.value;
};

const handleTitleMenuClickOutside = (event) => {
  if (!event.target.closest('.title-menu') && !event.target.closest('.mid-title-btn')) {
    showTitleMenu.value = false;
  }
};

// 切換 view
const setView = async (view) => {
  showTitleMenu.value = false;
  currentView.value = view;

  // 從 explore 切回管理頁時重置捲動位置，防止版型偏移
  if (view !== 'explore') {
    const el = document.querySelector('.game-act-manager');
    if (el) el.scrollTop = 0;
  }

  // 保存視圖偏好（登入用戶）
  if (profile.teammodelId) {
    localStorage.setItem(`gameact_view_preference_${profile.teammodelId}`, view);
  }

  if (view === 'myPublic') {
    search.value = '';
    publicSearch.value = '';
    publicCurrentPage.value = 1;
    await loadMyPublicGames();
  } else if (view === 'explore') {
    explorePage.value = 1;
    exploreItems.value = [];
    await loadExploreGames();
  }
};

// 載入我的公開展示列表
const loadMyPublicGames = async (page) => {
  if (!profile.teammodelId) return;
  if (page !== undefined) publicCurrentPage.value = page;
  isLoadingPublic.value = true;
  try {
    const res = await gameActivityAPI.getMyPublicCustomGames({
      tmid: profile.teammodelId,
      page: publicCurrentPage.value,
      pageSize: 12,
      searchText: (publicSearch.value || '').trim()
    });
    myPublicGameList.value = res?.data || [];
    publicTotalPages.value = res?.totalPages || 1;
    const pages = [];
    for (let i = 1; i <= publicTotalPages.value; i++) pages.push(i);
    publicPageBtns.value = pages;
  } catch (e) {
    console.error('載入公開展示失敗:', e);
  } finally {
    isLoadingPublic.value = false;
  }
};

// 載入探索公開展示列表
const loadExploreGames = async () => {
  isLoadingExplore.value = true;
  try {
    const res = await gameActivityAPI.getPublicCustomGames({
      search: exploreSearch.value.trim(),
      page: explorePage.value,
      pageSize: 24
    });
    const newItems = res?.items || [];
    if (explorePage.value === 1) {
      exploreItems.value = newItems;
      exploreCardColors.value = genExploreCardColors(newItems.length);
    } else {
      exploreItems.value = [...exploreItems.value, ...newItems];
      exploreCardColors.value = genExploreCardColors(exploreItems.value.length, exploreCardColors.value);
    }
    exploreHasMore.value = res?.hasMore || false;
    exploreTotal.value = res?.total || 0;
  } catch (e) {
    console.error('載入探索遊戲失敗:', e);
  } finally {
    isLoadingExplore.value = false;
  }
};

const searchExploreGames = async () => {
  explorePage.value = 1;
  exploreItems.value = [];
  await loadExploreGames();
};

const clearExploreSearch = async () => {
  exploreSearch.value = '';
  explorePage.value = 1;
  exploreItems.value = [];
  await loadExploreGames();
};

const loadMoreExplore = async () => {
  explorePage.value++;
  await loadExploreGames();
};

const playExploreGame = (item) => {
  if (!item?.id) return;
  item.viewCount = (item.viewCount || 0) + 1;
  window.open(`/public-aigame-play?publicId=${item.id}`, '_blank');
};

// 開啟檢視 modal
const openPublicViewModal = (item) => {
  showPublicActionMenu.value = false;
  publicViewItem.value = item;
  showPublicViewModal.value = true;
  console.log('[PublicGame]', JSON.parse(JSON.stringify(item)));
};

// 複製檢視連結
const copyPublicViewUrl = async () => {
  const url = shortURLHost + publicViewItem.value?.publicGameCode;
  try {
    await navigator.clipboard.writeText(url);
    $Message.success(t('gameActManager.publishSuccess.urlCopied'));
  } catch {
    $Message.error(t('gameActManager.copyFailed'));
  }
};

// 開啟 QR Code（檢視 modal 內）
const openPublicViewQRCode = () => {
  qrCodeUrl.value = shortURLHost + publicViewItem.value?.publicGameCode;
  publishedGameCode.value = publicViewItem.value?.publicGameCode || '';
  showPublicViewModal.value = false;
  showQRCodeCard.value = true;
};

// 馬上玩（開新分頁）
const playPublicGame = (item) => {
  if (!item?.id) return;
  window.open(`/public-aigame-play?publicId=${item.id}`, '_blank');
};

// 預覽遊戲（從 gameContentSettings 載入）
const previewPublicGame = (item) => {
  showPublicActionMenu.value = false;
  showPublicViewModal.value = false;
  if (!item?.gameContentSettings) {
    $Message.error('找不到遊戲內容');
    return;
  }
  try {
    const settings = JSON.parse(item.gameContentSettings);
    const previewData = {
      currentGame: 'aigame',
      gameParameters: settings
    };
    localStorage.setItem('game_preview_data', JSON.stringify(previewData));
    localStorage.setItem('game_preview_timestamp', Date.now().toString());
    window.open('/ht-aigame-play', '_blank');
  } catch (e) {
    $Message.error('預覽遊戲失敗');
  }
};

// 開啟公開展示操作選單
const openPublicActionMenu = (item, event) => {
  event.stopPropagation();
  currentPublicGame.value = item;
  const rect = event.target.getBoundingClientRect();
  publicActionMenuPos.x = rect.left - 80;
  publicActionMenuPos.y = rect.top + 20;
  showPublicActionMenu.value = true;
};

// 確認刪除公開版本
const confirmDeletePublicGame = () => {
  showPublicActionMenu.value = false;
  publicGameToDelete.value = currentPublicGame.value;
  showPublicDeleteConfirm.value = true;
};

// 執行刪除
const doDeletePublicGame = async () => {
  if (!publicGameToDelete.value || isDeletingPublic.value) return;
  isDeletingPublic.value = true;
  try {
    const res = await gameActivityAPI.deletePublicCustomGame({
      publicGameId: publicGameToDelete.value.id,
      tmid: profile.teammodelId
    });
    if (res && res.status === 200) {
      $Message.success(t('gameActManager.deletePublicSuccess'));
      myPublicGameList.value = myPublicGameList.value.filter(g => g.id !== publicGameToDelete.value.id);
      // 同步更新 gameActivityList 中對應的 isPublicDisplay
      const idx = gameActivityList.value.findIndex(a => a.publicGameId === publicGameToDelete.value.id);
      if (idx !== -1) {
        gameActivityList.value[idx].isPublicDisplay = false;
        gameActivityList.value[idx].publicGameId = null;
      }
      showPublicDeleteConfirm.value = false;
      publicGameToDelete.value = null;
    } else {
      throw new Error('delete failed');
    }
  } catch (e) {
    $Message.error(t('gameActManager.deletePublicFailed'));
  } finally {
    isDeletingPublic.value = false;
  }
};

// 開啟公開發佈 Dialog
const openPublishDialog = () => {
  showActionMenu.value = false;
  if (!currentActivity.value) return;
  publishTitle.value = currentActivity.value.activityName || '';
  publishSourceCodeOpen.value = false;
  showPublishDialog.value = true;
};

// 關閉公開發佈 Dialog
const closePublishDialog = () => {
  showPublishDialog.value = false;
};

// 確認發佈 / 更新
const confirmPublish = async () => {
  if (!publishTitle.value.trim() || isPublishing.value) return;
  isPublishing.value = true;
  const isUpdate = !!currentActivity.value?.isPublicDisplay;
  try {
    const payload = {
      id: currentActivity.value.id,
      tmid: profile.teammodelId,
      title: publishTitle.value.trim(),
      isSourceCodeOpen: publishSourceCodeOpen.value
    };
    let response;
    if (isUpdate) {
      response = await gameActivityAPI.updatePublicCustomGame(payload);
    } else {
      response = await gameActivityAPI.publishCustomGame(payload);
    }
    if (response && response.status === 200) {
      showPublishDialog.value = false;
      const publicId = response.publicId || '';
      publishedPublicId.value = publicId;

      // 取短碼：若已有則直接用，否則呼叫 ClipCode API
      let gameCode = response.publicGameCode || response.data?.publicGameCode || '';
      if (!gameCode && publicId) {
        try {
          const clipUrl = `${window.location.origin}/public-aigame-play?publicId=${publicId}`;
          const clipRes = await gameActivityAPI.createClipCode(clipUrl, locale.value, JSON.stringify({ gameName: publishTitle.value }));
          gameCode = clipRes?.clipCodePairs?.[0]?.clipCode || '';
          if (gameCode) {
            await gameActivityAPI.updatePublicCustomGame({
              id: currentActivity.value.id,
              tmid: profile.teammodelId,
              publicGameCode: gameCode
            });
          }
        } catch (e) {
          console.error('取短碼失敗:', e);
        }
      }
      publishedGameCode.value = gameCode || publicId;

      // 同步更新本地列表中的 isPublicDisplay / publicGameId
      const idx = gameActivityList.value.findIndex(a => a.id === currentActivity.value.id);
      if (idx !== -1) {
        gameActivityList.value[idx].isPublicDisplay = true;
        gameActivityList.value[idx].publicGameId = publicId;
        currentActivity.value = gameActivityList.value[idx];
      }
      $Message.success(isUpdate ? t('gameActManager.updatePublicSuccessMsg') : t('gameActManager.publishSuccessMsg'));
      showPublishSuccessModal.value = true;
      // 重新載入公開展示列表（保持資料同步）
      await loadMyPublicGames();
    } else {
      throw new Error('API returned non-200');
    }
  } catch (error) {
    $Message.error(isUpdate ? t('gameActManager.updatePublicFailed') : t('gameActManager.publishFailed'));
  } finally {
    isPublishing.value = false;
  }
};

// 複製公開 ID 到剪貼簿
const copyPublicId = async () => {
  try {
    await navigator.clipboard.writeText(shortURLHost + publishedGameCode.value);
    $Message.success(t('gameActManager.publishSuccess.urlCopied'));
  } catch {
    $Message.error(t('gameActManager.copyFailed'));
  }
};

// 開啟 QR Code
const openPublishQRCode = () => {
  qrCodeUrl.value = shortURLHost + publishedGameCode.value;
  showQRCodeCard.value = true;
};

// 複製活動
const duplicateActivity = async () => {
  showActionMenu.value = false;
  if (!currentActivity.value) return;

  try {
    $q.loading.show();

    // 建立複製的活動資料（排除成績和邀請碼相關欄位）
    const originalActivity = currentActivity.value;
    const newActivityName = `${originalActivity.activityName}${t('gameActManager.copySuffix')}`;

    // 解析並更新遊戲內容設定中的 topic 欄位
    let gameContentSettings = originalActivity.gameContentSettings || '{}';
    try {
      const settings = JSON.parse(gameContentSettings);
      settings.topic = newActivityName; // 更新主題為新的活動名稱
      gameContentSettings = JSON.stringify(settings);
    } catch (error) {
      console.error('解析遊戲設定失敗，使用原始設定:', error);
    }

    // 確保必要欄位存在
    const duplicatedData = {
      activityName: newActivityName,
      creator: {
        id: profile.teammodelId,
        name: profile.name
      },
      currentGame: originalActivity.currentGame,
      questionType: originalActivity.questionType,
      gameContentSettings: gameContentSettings,
      classRosterSource: originalActivity.classRosterSource,
      classRoster: JSON.stringify({ students: [] }), // 清空班級名單
      shortUrlCode: '', // 清空短網址
      enableEntry: false, // 重置為未開放
      playerCount: originalActivity.playerCount,
      allowTemplateChange: originalActivity.allowTemplateChange
    };

    console.log('複製活動資料:', duplicatedData);

    // 呼叫 API 建立新活動
    const response = await gameActivityAPI.createGameActivity(duplicatedData);

    console.log('複製活動成功:', response);
    $Message.success(t('gameActManager.activityDuplicated'));

    // 重新載入活動列表
    await loadGameActivities();
    $q.loading.hide();

    // 開啟新複製的活動設定視窗
    try {
      const createdActivity = (response && response.data) ? response.data : response;
      let target = null;

      if (createdActivity && createdActivity.id) {
        target = gameActivityList.value.find(a => a.id === createdActivity.id) || null;
      }

      // 若無法由回傳值判定，取列表第一筆（列表以 createTime desc 排序，最新在前）
      if (!target && Array.isArray(gameActivityList.value) && gameActivityList.value.length > 0) {
        target = gameActivityList.value[0];
      }

      if (target) {
        currentActivity.value = target;
        showUpdateModal.value = true;
      }
    } catch (e) {
      console.error('開啟更新視窗時發生錯誤:', e);
    }
  } catch (error) {
    console.error('複製活動失敗:', error);

    // 檢查是否為活動數量超限錯誤
    const isLimitExceeded = error.response?.data?.errorCode === 'ACTIVITY_LIMIT_EXCEEDED' ||
                           error.response?.data?.message?.includes('已達活動數量上限') ||
                           error.response?.data?.message?.includes('已达活动数量上限');

    if (isLimitExceeded) {
      const maxLimit = error.response?.data?.maxLimit || 120;
      $Message.warning({
        content: t('gameActManager.activityLimitExceeded', { maxLimit }),
        duration: 6,
        closable: true
      });
    } else {
      $Message.error(error.message || t('gameActManager.activityDuplicateFailed'));
    }

    $q.loading.hide();
  }
};

// 切換遊戲選擇彈窗
const toggleGameSelectionModal = () => {
  showGameSelectionModal.value = true;
};

// 關閉遊戲選擇彈窗
const closeGameSelectionModal = () => {
  showGameSelectionModal.value = false;
};

// 切換新增選單（保留，以防其他地方使用）
const toggleAddMenu = () => {
  showAddMenu.value = !showAddMenu.value;
};

// 點擊外部關閉新增選單
const handleAddMenuClickOutside = (event) => {
  if (!event.target.closest('.add-menu') && !event.target.closest('.add-btn')) {
    showAddMenu.value = false;
  }
};

// 建立活動相關狀態
const showCreateModal = ref(false);
const selectedQuestionType = ref('');
// 建立活動：遊戲詳細內容設定預設值
const getDefaultGameSettings = (gameType, questionType) => {
  return {
    playerCount: 1,
    currentGame: gameType,
    allowTemplateChange: false,
    gameParameters: {}
  };
};
const defaultGameSettings = ref(getDefaultGameSettings('mole', 'recognition'));

// 更新活動相關狀態
const showUpdateModal = ref(false);

// 引導組件 ref
const guideStep1Ref = ref(null);
const addButtonRef = ref(null);

// 處理「+ 新增」按鈕點擊
const handleAddButtonClick = () => {
  // 隱藏步驟一引導
  if (guideStep1Ref.value) {
    guideStep1Ref.value.hideGuide();
  }
  // 開啟遊戲選擇彈窗
  toggleGameSelectionModal();
};

// 建立遊戲活動（新方法：指定遊戲類型和題型）
const createGameActivity = (gameType, questionType) => {
  closeGameSelectionModal();
  selectedQuestionType.value = questionType;
  // 設定預設遊戲設定
  defaultGameSettings.value = getDefaultGameSettings(gameType, questionType);
  showCreateModal.value = true;
};

// 建立活動（保留舊方法，以防其他地方使用）
const createActivity = (type) => {
  showAddMenu.value = false;
  selectedQuestionType.value = type;
  // 每次開啟前重置預設設定（根據題型）
  defaultGameSettings.value = getDefaultGameSettings('mole', type);
  showCreateModal.value = true;
};

// Modal 關閉處理
const handleModalClose = () => {
  showCreateModal.value = false;
  selectedQuestionType.value = '';
};

// 活動建立成功處理
const handleActivityCreated = async () => {
  showCreateModal.value = false;
  selectedQuestionType.value = '';
  $Message.success(t('gameActManager.activityCreated'));
  $q.loading.show();
  await loadGameActivities();
  await loadActivityUsage();
  $q.loading.hide();
};

// 更新 Modal 關閉處理
const handleUpdateModalClose = () => {
  showUpdateModal.value = false;
};

// 活動更新成功處理
const handleActivityUpdated = async () => {
  showUpdateModal.value = false;
  $Message.success(t('gameActManager.activityUpdated'));

  // 重新載入活動列表
  $q.loading.show();
  await loadGameActivities();
  $q.loading.hide();
};

// Avatar 選單
const OpenAvatarMenu = () => {
  showNavMenu.value = !showNavMenu.value;
};

const handleNavClickOutside = (event) => {
    if (!event.target.closest('.nav-menu') && !event.target.closest('.avatar')) {
        showNavMenu.value = false;
    }
}

// 登出
const logout = () => {
    showNavMenu.value = false;
    if (isLogin.value) {
        // 檢查是否在 WebView 環境
        const isWebView = window?.chrome?.webview ? true : false;

        api.main.logout().then(async () => {
            $Message.info("已登出");
            isLogin.value = false;
            store.setIsLogIn(false);
            localStorage.clear();
            sessionStorage.clear();

            // 如果在 WebView 環境，導航回 HTwbActKitHome 並重整畫面
            if (isWebView) {
                window.location.href = '/htwb-actkit-home';
                return;
            }

            // 登出後切回探索首頁
            currentView.value = 'explore';
            explorePage.value = 1;
            exploreItems.value = [];
            await loadExploreGames();
        });
    }
}

// 登入
const loginTMID = () => {
    api.main.loginTmdID();
};

// 製作新遊戲 → 開啟 GPT 遊戲製作大師
const openCreateGameGPT = () => {
    window.open('https://chatgpt.com/g/g-69fbfd146a7881918d7f828207a412d8-hiteach-zhuo-you-zhi-zuo-da-shi', '_blank');
};

// 格式化時間（支援秒與毫秒時間戳）
const getTime = (timestamp) => {
  if (timestamp === null || timestamp === undefined || timestamp === '') return '';
  const n = Number(timestamp);
  if (Number.isNaN(n)) return '';
  // 小於 1e12 視為秒，需要轉毫秒
  const ms = n < 1e12 ? n * 1000 : n;
  const date = new Date(ms);
  return date.toLocaleDateString('zh-TW');
};

// 取得公開展示卡片圖片（有縮圖用縮圖，否則用預設封面）
const getPublicGameImage = (item) => {
  if (item.snapshotUrl) return item.snapshotUrl;
  return require('@/assets/HTwbActAssets/home/cover-aigame.webp');
};

// 取得活動背景圖
const getActivityBackgroundImage = (activity) => {
  try {
    // 解析 gameContentSettings
    const settings = activity.gameContentSettings
      ? JSON.parse(activity.gameContentSettings)
      : {};

    const background = settings.background || 'forest';
    const currentGame = activity.currentGame || 'mole';

    // 根據遊戲類型和背景設定返回對應圖片
    if (currentGame === 'mole') {
      // 打地鼠遊戲
      if (background === 'forest') {
        return require('@/assets/HTwbActAssets/MolegameObj/mole-forest.webp');
      } else if (background === 'desert') {
        return require('@/assets/HTwbActAssets/MolegameObj/mole-desert.webp');
      }
    } else if (currentGame === 'star') {
      // 摘星星遊戲 - 統一使用 cover-pvpgame.webp
      return require('@/assets/HTwbActAssets/home/cover-pvpgame.webp');
    } else if (currentGame === 'tf') {
      // 火箭升空遊戲（是非題）
      return require('@/assets/HTwbActAssets/home/cover-tfgame.webp');
    } else if (currentGame === 'snake') {
      // 貪食蛇遊戲
      return require('@/assets/HTwbActAssets/home/cover-snakegame.webp');
    } else if (currentGame === 'maze') {
      // 迷宮遊戲（單選題）
      return require('@/assets/HTwbActAssets/home/cover-mazegame.webp'); // 暫時使用貪食蛇圖片，待確認實際圖片路徑
    } else if (currentGame === 'aigame') {
      return activity.thumbnailUrl || require('@/assets/HTwbActAssets/home/cover-aigame.webp');
    }

    // 預設圖片
    return require('@/assets/HTwbActAssets/MolegameObj/mole-forest.webp');
  } catch (error) {
    console.error('解析活動背景圖失敗:', error);
    return require('@/assets/HTwbActAssets/MolegameObj/mole-forest.webp');
  }
};
</script>

<style lang="less">
@import "../assets/color.less";

.game-act-manager {
    .select-btn {
        &:focus {
            --tw-ring-color: @light-color !important;
        }

        .arrow-icon-up {
            color: @light-color !important;
        }
    }
}
</style>

<style lang="less" scoped>
@import "../assets/gameActManager.less";

.publish-dialog-modal,
.publish-success-modal {
  width: 420px;
  max-width: 92vw;

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    border-bottom: 1px solid #e8e8e8;

    h3 {
      margin: 0;
      color: #333;
      font-size: 18px;
      font-weight: 600;
      line-height: 1.2;
    }

    .close-btn {
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      color: #999;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover { color: #666; }
      :deep(svg) { width: 20px; height: 20px; }
    }
  }

  .modal-body {
    padding: 20px 24px;
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 12px 24px 20px;
  }

  .overwrite-hint {
    background: #fffbeb;
    border: 1px solid #fcd34d;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 13px;
    color: #92400e;
    margin-bottom: 16px;
  }

  .form-group {
    margin-bottom: 20px;
    &:last-child { margin-bottom: 0; }
  }

  .form-label {
    display: block;
    font-size: 14px;
    font-weight: 700;
    color: #333;
    margin-bottom: 8px;
    line-height: 1.6;
  }

  .form-input {
    width: 100%;
    padding: 5px 12px;
    font-size: 20px;
    line-height: 1.6;
    border: 2px solid #d9d9d9;
    border-radius: 6px;
    color: #000;
    font-weight: bolder;
    box-sizing: border-box;
    transition: border-color 0.2s;
    &:focus { outline: none; border-color: #667eea; }
    &::placeholder { color: #bfbfbf; font-weight: normal; }
  }

  .source-code-group {
    .toggle-label {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      cursor: pointer;
      margin: 0;
    }

    .toggle-text {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .toggle-name {
      font-size: 16px;
      font-weight: 700;
      color: #333;
    }

    .toggle-desc {
      font-size: 13px;
      color: #666;
      line-height: 1.5;
    }

    .toggle-checkbox {
      width: 18px;
      height: 18px;
      margin-top: 3px;
      cursor: pointer;
      flex-shrink: 0;
      accent-color: #667eea;
    }
  }

  // 公開展示 URL 列（與 UpdateActivityModal 完全一致）
  .url-wrap {
    background-color: #fff9c4;
    padding: 10px;
    color: #667eea;
    margin: 0;
    font-weight: bold;
    border-radius: 5px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 6px;
    word-wrap: break-word;
    overflow-wrap: break-word;

    .url-title {
      color: #333 !important;
      word-break: break-word;
      white-space: normal;
    }

    .short-url {
      color: black !important;
      word-break: break-word;
      font-size: 28px;
      white-space: nowrap;
      background-color: #fff;
      padding: 5px;
      border-radius: 3px;
      font-weight: bold;
    }

    .copy-btn {
      color: #333;
      font-size: 20px;
      cursor: pointer;
      display: flex;
      align-items: center;
      &:hover { opacity: 0.7; }
    }

    .qrcode-btn {
      color: #333;
      font-size: 25px;
      cursor: pointer;
      display: flex;
      align-items: center;
      &:hover { opacity: 0.7; }
    }
  }
}

.public-view-modal {
  width: 520px;
  max-width: 92vw;

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 13px 16px;
    border-bottom: 1px solid #e8e8e8;
    h3 { margin: 0; font-size: 16px; font-weight: 600; color: #333; line-height: 1.4; }
    .close-btn {
      background: none; border: none; cursor: pointer; padding: 4px; color: #999;
      display: flex; align-items: center; justify-content: center;
      &:hover { color: #666; }
      :deep(svg) { width: 18px; height: 18px; }
    }
  }

  .modal-body { padding: 16px; }

  .view-link-row {
    display: flex;
    align-items: center;
    gap: 12px;

    .url-wrap {
      flex: 1;
      background-color: #fff9c4;
      padding: 10px;
      color: #667eea;
      font-weight: bold;
      border-radius: 5px;
      display: flex;
      align-items: center;
      gap: 6px;
      overflow: hidden;

      .url-title {
        color: #333;
        white-space: nowrap;
        font-size: 14px;
      }

      .short-url {
        color: black;
        font-size: 22px;
        white-space: nowrap;
        background-color: #fff;
        padding: 3px 6px;
        border-radius: 3px;
        font-weight: bold;
      }

      .copy-btn, .qrcode-btn {
        color: #333;
        cursor: pointer;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        font-size: 20px;
        &:hover { opacity: 0.7; }
      }
    }
  }

  .play-now-btn {
    background: #667eea;
    color: white;
    border: none;
    border-radius: 6px;
    padding: 8px 20px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 600;
    white-space: nowrap;
    flex-shrink: 0;
    &:hover { background: #5568d3; }
  }
}

.cancel-btn {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 8px 20px;
  cursor: pointer;
  font-size: 14px;
  &:hover:not(:disabled) { background: #e5e7eb; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
}

.confirm-btn {
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 20px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  &:hover:not(:disabled) { background: #5568d3; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
}

/* ===============================================
   Explore Mode — Root
   =============================================== */
.gam-explore-mode {
  background: #FAF7F2;
  background-image: radial-gradient(circle at 1px 1px, rgba(26,26,46,.04) 1px, transparent 0);
  background-size: 24px 24px;
}

/* ===============================================
   Arcade Navbar (explore mode)
   =============================================== */
.flex-bar-arcade {
  border-bottom: none !important;
}

.flex-bar-arcade {
  .arcade-logo {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    color: #1A1A2E;
    cursor: pointer;

    .arcade-logo-icon {
      width: 36px;
      height: 36px;
      border-radius: 10px;
      background: #1A1A2E;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .arcade-logo-text {
      white-space: nowrap;
      display: inline-flex;
      align-items: baseline;
      gap: 4px;

      .arcade-hiteach {
        font-family: 'Noto Sans TC', 'Inter', sans-serif;
        font-weight: 900;
        font-size: 15px;
        color: #1A1A2E;
        letter-spacing: -.01em;
      }

      .arcade-name {
        font-family: Impact, 'Arial Black', 'Noto Sans TC', sans-serif;
        font-size: 20px;
        letter-spacing: 1.5px;
        line-height: 1;
        color: #1A1A2E;
      }
    }
  }

  .arcade-center-search {
    flex: 1;
    max-width: 480px;
    margin: 0 auto;

    .arcade-search-bar {
      display: flex;
      align-items: center;
      gap: 10px;
      background: white;
      border: 2.5px solid #1A1A2E;
      border-radius: 999px;
      padding: 7px 7px 7px 18px;
      box-shadow: 3px 3px 0 #1A1A2E;
      transition: box-shadow .2s;
      cursor: text;

      &:focus-within {
        box-shadow: 5px 5px 0 #3B82F6;
      }

      input {
        flex: 1;
        border: none;
        background: transparent;
        outline: none;
        font-size: 14px;
        color: #1A1A2E;
        min-width: 0;
        &::placeholder { color: #8A8AA0; }
      }

      .arcade-search-clear {
        cursor: pointer;
        color: #8A8AA0;
        display: flex;
        align-items: center;
        font-size: 16px;
        &:hover { color: #1A1A2E; }
      }

      .arcade-search-btn {
        background: #7B5DD7;
        border: none;
        border-radius: 999px;
        width: 30px;
        height: 30px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: white;
        flex-shrink: 0;
        transition: opacity .2s;
        &:hover { opacity: .85; }
      }
    }
  }

  .arcade-btn-ghost {
    display: inline-flex;
    align-items: center;
    padding: 8px 16px;
    border-radius: 999px;
    border: 2.5px solid #1A1A2E;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    background: white;
    color: #1A1A2E;
    box-shadow: 3px 3px 0 #1A1A2E;
    white-space: nowrap;
    transition: transform .15s, box-shadow .15s;
    &:hover { transform: translate(-1px,-1px); box-shadow: 4px 4px 0 #1A1A2E; }
    &:active { transform: translate(2px,2px); box-shadow: 1px 1px 0 #1A1A2E; }
  }

  .arcade-btn-primary {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border-radius: 999px;
    border: 2.5px solid #1A1A2E;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    background: #7B5DD7;
    color: white;
    box-shadow: 3px 3px 0 #1A1A2E;
    white-space: nowrap;
    transition: transform .15s, box-shadow .15s;
    &:hover { transform: translate(-1px,-1px); box-shadow: 4px 4px 0 #1A1A2E; }
    &:active { transform: translate(2px,2px); box-shadow: 1px 1px 0 #1A1A2E; }
  }

  .my-games-pill {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 4px 4px 4px 18px;
    border-radius: 999px;
    border: 1.5px solid #E8E3D8;
    background: white;
    color: #1A1A2E;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: border-color .2s;
    &:hover { border-color: #1A1A2E; }

    .avatar {
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
  }
}

/* ===============================================
   Explore Full Page
   =============================================== */
.gam-explore-page {
  min-height: 100vh;
}

.gam-container {
  padding: 0 40px;

  @media (max-width: 768px) { padding: 0 20px; }
}

/* Hero */
.gam-hero {
  position: relative;
  overflow: hidden;
  padding: 60px 0 140px;
  background: #FAF7F2;

  .gam-hero-spotlight {
    position: absolute;
    left: 50%; top: 45%;
    transform: translate(-50%, -50%);
    width: 70%; height: 90%;
    background: radial-gradient(ellipse at center, rgba(59,130,246,.10), transparent 60%);
    pointer-events: none;
  }

  .gam-hero-inner {
    position: relative;
    z-index: 3;
    text-align: center;
    margin: 0 auto;
    padding: 0 24px;

    .gam-hero-title {
      font-weight: 900;
      font-size: clamp(28px, 3.6vw, 58px);
      line-height: 1.1;
      margin: 0 0 20px;
      color: #1A1A2E;
      letter-spacing: -.02em;
      white-space: nowrap;

      .gam-title-blue { color: #3B82F6; }
      .gam-title-orange { color: #FF8A3D; }
    }

    .gam-hero-sub {
      color: #4A4A63;
      font-size: 16px;
      max-width: 560px;
      margin: 0 auto 28px;
      line-height: 1.6;
    }

    .gam-hero-cta {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 16px;
      flex-wrap: wrap;
    }
  }
}

/* Sparkles */
@keyframes gam-twinkle {
  0%, 100% { opacity: 0.3; transform: scale(.7) rotate(0deg); }
  50% { opacity: 1; transform: scale(1) rotate(180deg); }
}
.gam-sparkle {
  position: absolute;
  pointer-events: none;
  z-index: 1;
  animation: gam-twinkle var(--tdur, 3s) ease-in-out infinite var(--tdelay, 0s);
  text-shadow: 0 0 12px currentColor;
}

/* Score popups */
@keyframes gam-bob {
  0%, 100% { transform: translateY(0) rotate(var(--rot, -8deg)); }
  50% { transform: translateY(-4px) rotate(var(--rot, -8deg)); }
}
.gam-score-popup {
  position: absolute;
  color: white;
  padding: 4px 10px;
  font-family: 'Noto Sans TC', sans-serif;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: .04em;
  border-radius: 4px;
  box-shadow: 3px 3px 0 #1A1A2E;
  border: 2px solid #1A1A2E;
  z-index: 2;
  white-space: nowrap;
  pointer-events: none;
  animation: gam-bob 2.4s ease-in-out infinite;
}

/* Floating cartridges */
@keyframes gam-floaty {
  0%, 100% { transform: translateY(0) rotate(var(--rot, 0deg)); }
  50% { transform: translateY(-8px) rotate(var(--rot, 0deg)); }
}
.gam-floaty {
  animation: gam-floaty var(--dur, 6s) ease-in-out infinite var(--delay, 0s);
}

.gam-cartridge {
  position: absolute;
  z-index: 2;
  pointer-events: none;
  transform: rotate(var(--rot, 0deg));

  .gam-cart-inner {
    border-radius: 14px;
    padding: 8px;
    border: 3px solid #1A1A2E;
    position: relative;
    filter: drop-shadow(0 14px 24px rgba(26,26,46,.18));

    .gam-cart-label {
      margin-top: 6px;
      padding: 4px 8px;
      background: #FFF8E7;
      border-radius: 4px;
      border: 1.5px solid #1A1A2E;
      display: flex;
      flex-direction: column;
      gap: 1px;

      .gam-cart-title {
        font-size: 11px;
        font-weight: 900;
        color: #1A1A2E;
        line-height: 1.1;
        font-family: 'Noto Sans TC', sans-serif;
      }
      .gam-cart-sub {
        font-size: 8px;
        color: #4A4A63;
        font-weight: 600;
        font-family: 'JetBrains Mono', monospace;
        letter-spacing: .02em;
      }
    }
  }
}

/* Game Cover mini graphics */
.gam-cover-mole, .gam-cover-ai, .gam-cover-tf, .gam-cover-snake, .gam-cover-star, .gam-cover-maze {
  width: 100%;
  aspect-ratio: 4/3;
  border-radius: 6px;
  border: 2px solid rgba(0,0,0,.2);
  position: relative;
  overflow: hidden;
}
.gam-cover-mole {
  background: linear-gradient(180deg, #7BD68D 0%, #3FB360 60%);
  &::before {
    content: '';
    position: absolute;
    left: 38%; top: 48%;
    width: 22%; aspect-ratio: 1/1;
    background: #8B5A2B;
    border-radius: 50% 50% 45% 45%;
  }
  &::after {
    content: '';
    position: absolute;
    left: 0; right: 0; bottom: 0;
    height: 14%;
    background: #5C3317;
  }
}
.gam-cover-ai {
  background: radial-gradient(ellipse at 30% 30%, #9F85E5, #7B5DD7);
  &::before {
    content: 'AI';
    position: absolute;
    left: 50%; top: 50%;
    transform: translate(-50%,-50%);
    font-size: 24px;
    font-weight: 900;
    color: white;
    text-shadow: 2px 3px 0 rgba(0,0,0,.25);
  }
}
.gam-cover-tf {
  background: linear-gradient(180deg, #3B5BC4 0%, #1E3A8A 90%);
  &::before {
    content: '';
    position: absolute;
    left: 45%; top: 38%;
    width: 9%; height: 34%;
    background: #FF8A3D;
    border-radius: 50% 50% 4px 4px;
  }
}
.gam-cover-snake {
  background: #0F1729;
  &::before {
    content: '';
    position: absolute;
    inset: 8% 8%;
    background-image: linear-gradient(#1E2A4A 1px, transparent 1px), linear-gradient(90deg, #1E2A4A 1px, transparent 1px);
    background-size: 14% 14%;
    opacity: .6;
  }
}
.gam-cover-star {
  background: linear-gradient(180deg, #FFB37A 0%, #FF8A3D 100%);
  &::after {
    content: '★';
    position: absolute;
    left: 50%; top: 40%;
    transform: translate(-50%,-50%);
    font-size: 28px;
    color: white;
    text-shadow: 1px 2px 0 rgba(0,0,0,.2);
  }
}
.gam-cover-maze {
  background: linear-gradient(135deg, #60A5FA, #2563EB);
}
.gam-cover-ai-full {
  width: 100%;
  height: 100%;
  background: radial-gradient(ellipse at 30% 30%, #9F85E5, #7B5DD7);
  &::before {
    content: 'AI';
    position: absolute;
    left: 50%; top: 50%;
    transform: translate(-50%,-50%);
    font-size: 48px;
    font-weight: 900;
    color: white;
    text-shadow: 2px 3px 0 rgba(0,0,0,.25);
  }
}

/* Buttons */
.gam-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 13px 26px;
  border-radius: 999px;
  border: 2.5px solid #1A1A2E;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  background: #7B5DD7;
  color: white;
  box-shadow: 3px 3px 0 #1A1A2E;
  transition: transform .15s, box-shadow .15s;
  font-family: 'Noto Sans TC', sans-serif;
  &:hover { transform: translate(-1px,-1px); box-shadow: 4px 4px 0 #1A1A2E; }
  &:active { transform: translate(2px,2px); box-shadow: 1px 1px 0 #1A1A2E; }
}

.gam-btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border-radius: 999px;
  border: 2.5px solid #1A1A2E;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  background: white;
  color: #1A1A2E;
  box-shadow: 3px 3px 0 #1A1A2E;
  transition: transform .15s, box-shadow .15s;
  &:hover { transform: translate(-1px,-1px); box-shadow: 4px 4px 0 #1A1A2E; }
  &:active { transform: translate(2px,2px); box-shadow: 1px 1px 0 #1A1A2E; }
}

/* Wiggle on hover */
@keyframes gam-wiggle {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(-3deg); }
  75% { transform: rotate(3deg); }
}
.gam-wiggle:hover { animation: gam-wiggle .4s ease-in-out; }

/* Explore Section */
.gam-explore-section {
  background: #F2EEE5;
  border-top: 1px solid #E8E3D8;
  border-bottom: 1px solid #E8E3D8;
  padding: 28px 40px 48px;

  @media (max-width: 768px) { padding: 20px 16px 32px; }

  .gam-explore-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 28px;
    gap: 24px;
    flex-wrap: wrap;

    .gam-explore-header-left {
      .gam-explore-title-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 8px;

        .gam-flame-icon {
          display: inline-flex;
          align-items: center;
          flex-shrink: 0;
        }

        .gam-explore-title {
          margin: 0;
          font-size: 32px;
          font-weight: 900;
          letter-spacing: -.02em;
          line-height: 1;
          color: #1A1A2E;
        }
      }

      .gam-explore-sub {
        margin: 0;
        color: #4A4A63;
        font-size: 14px;
        line-height: 1.5;
      }
    }

    .gam-explore-search-wrap {
      .gam-section-search {
        display: flex;
        align-items: center;
        gap: 8px;
        background: white;
        border: 2.5px solid #1A1A2E;
        border-radius: 999px;
        padding: 7px 14px;
        box-shadow: 3px 3px 0 #1A1A2E;
        width: 280px;
        transition: box-shadow .2s;
        cursor: text;

        &:focus-within { box-shadow: 5px 5px 0 #3B82F6; }

        input {
          flex: 1;
          border: none;
          background: transparent;
          outline: none;
          font-size: 13px;
          color: #1A1A2E;
          min-width: 0;
          &::placeholder { color: #8A8AA0; }
        }

        .gam-del-btn {
          cursor: pointer;
          color: #8A8AA0;
          display: flex;
          align-items: center;
          font-size: 14px;
          &:hover { color: #1A1A2E; }
        }
      }
    }
  }

  .gam-explore-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;

    @media (max-width: 1400px) { grid-template-columns: repeat(4, 1fr); }
    @media (max-width: 1024px) { grid-template-columns: repeat(3, 1fr); }
    @media (max-width: 768px) { grid-template-columns: repeat(2, 1fr); }
    @media (max-width: 520px) { grid-template-columns: 1fr; }
  }

  // 照心智圖首頁 .gallery-card 完全一致
  .gam-arcade-card {
    background: white;
    border-radius: 14px;
    border: 2px solid #2b2c31;
    box-shadow: 3px 3px 0 #2b2c31;
    cursor: pointer;
    overflow: hidden;
    transition: box-shadow 0.18s ease, transform 0.18s ease;

    &:hover {
      transform: translate(-2px, -2px);
      box-shadow: 5px 5px 0 #2b2c31;
    }

    .gam-card-img {
      height: 190px;
      width: 100%;
      position: relative;
      border-bottom: 2px solid #2b2c31;
      overflow: hidden;
      background-color: #eef1f0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      .gam-views-badge {
        position: absolute;
        top: 8px;
        right: 8px;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 3px 10px;
        border-radius: 999px;
        background: rgba(43,44,49,0.72);
        backdrop-filter: blur(4px);
        color: white;
        font-size: 11px;
        font-weight: 700;
      }
    }

    .gam-card-info {
      padding: 10px 12px 12px;
      min-width: 0;

      .gam-card-meta {
        display: flex;
        align-items: center;
        gap: 4px;
        margin-bottom: 4px;

        .gam-card-author {
          font-size: 12px;
          color: #2b2c31;
        }
        .gam-card-dot {
          font-size: 11px;
          color: #2b2c31;
        }
        .gam-card-date {
          font-size: 11px;
          color: #2b2c31;
        }
      }

      .gam-card-title {
        font-size: 18px;
        font-weight: 800;
        color: #1a1b1e;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0;
        line-height: 1.4;
        max-width: 100%;
      }
    }
  }

  .gam-explore-empty {
    text-align: center;
    color: #8A8AA0;
    padding: 80px 0;
    font-size: 16px;
  }

  .gam-load-more {
    text-align: center;
    margin-top: 32px;

    .gam-load-more-count {
      color: #8A8AA0;
      margin-left: 8px;
      font-size: 11px;
      font-family: monospace;
    }
  }
}

.gam-footer {
  width: 100%;
  padding: 12px 24px 16px;
  text-align: center;
  font-size: 12px;
  color: #777;
  background-color: #f5f7f7;
  box-sizing: border-box;
}
</style>
